// components/YearRangeSelector.js
import React, { Component } from "react";
import { withState } from "react-searchkit";
import { Slider } from "react-semantic-ui-range";
import debounce from 'lodash.debounce';

class YearRangeSelectorComponent extends Component {
    constructor(props) {
        super(props);
        const allSelectedFilters = props.currentQueryState.filters.find((f) => f[0] === props.agg.field);
        let selectedFilters = [props.minYear, props.maxYear];
        if (allSelectedFilters) {
            selectedFilters = allSelectedFilters[1].split("--");
        }
        this.state = {
            yearRange: [selectedFilters[0] || props.minYear, selectedFilters[1] || props.maxYear],
            small: 1000,
            big: 9999,
            loading: true,
        };
        this.agg = props.agg;
        this.handleYearChange = this.handleYearChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    // Debounce the search by 300ms due to slider
    debouncedQuery = debounce((value) => {
        const { updateQueryState } = this.props;
        updateQueryState(value);
    }, 300);

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.currentResultsState.loading && !this.props.currentResultsState.loading && prevState.loading) {
            const buckets = this.props.currentResultsState.data.aggregations.publication_date.buckets
            const small = parseInt(buckets?.[0]?.key || 2000);
            const big = parseInt(buckets?.[buckets.length - 1]?.key || 2100);
            let yearRange = [small, big];
            const currentStateFilter = this.props.currentQueryState.filters.find((q) => q[0] === this.props.agg.field);
            if (currentStateFilter) {
                // This is for checking, if we have predefined
                // filter (in e.g. URL). If so, set the selection
                // to that.
                yearRange = currentStateFilter[1].split("--");
            }
            this.setState({ small, big, yearRange, loading: false, });
        }
    }

    handleYearChange(newRange) {
        this.setState({ yearRange: newRange });

        const { currentQueryState } = this.props;
        const filters = currentQueryState.filters.filter((f) => {
            return f[0] !== this.agg.field;
        })
        this.debouncedQuery({
            ...currentQueryState,
            filters: [
                ...filters,
                [this.agg.field, newRange[0] + "--" + newRange[1]]
            ],
        });
    }

    handleInputChange(index, value) {
        const num = parseInt(value, 10);
        if (!isNaN(num)) {
            const newRange = [...this.state.yearRange];
            newRange[index] = num;
            this.handleYearChange(newRange);
        }
    }


    render() {
        const { yearRange } = this.state;
        const settings = {
            start: [yearRange[0], yearRange[1]],
            min: this.state.small,
            max: this.state.big,
            step: 1,
            onChange: value => {
                if (this.state.yearRange[1] === value[1]) {
                    this.handleInputChange(0, value[0]);
                } else {
                    this.handleInputChange(1, value[1]);
                }
            }
        };

        return (
            <div className="ui card borderless facet">
                <div className="content">
                    <h2 className="header">{this.agg.title}</h2>
                    <Slider multiple color="blue" settings={settings} key={this.state.big} />
                    <div className="ui row">
                        <div className="ui input">
                            <input
                                type="number"
                                value={yearRange[0]}
                                min={this.state.small}
                                max={yearRange[1]}
                                onChange={(e) => this.handleInputChange(0, e.target.value)}
                            />
                        </div>
                        <span className="column"> to </span>
                        <div className="ui input">
                            <input
                                type="number"
                                value={yearRange[1]}
                                min={yearRange[0]}
                                max={this.state.big}
                                onChange={(e) => this.handleInputChange(1, e.target.value)}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export const YearRangeSelector = withState(YearRangeSelectorComponent);
